import React, { Component } from "react";
import "../../Controls/ListingPage.css";
import Input from "../../Controls/Input";

class WarehouseIntegration extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      selectedIntegrationType:""
    };
  }



  render() {

    return (
      <>
    <div>
         PaymentGateway integration
        
      </div>
      </>
    );

  }

}

export default WarehouseIntegration;